export default function Mentions(Utils, PersonaCollection) {
  'ngInject';

  class MentionsFactory {
    constructor(users = []) {
      this.users = users;
      this.matchedPersonas = [];
    }

    get users() {
      return this._users;
    }

    set users(val) {
      this._users = val;

      const userIds = val.map((u) => u.id);
      this.personas = PersonaCollection.personas.filter((persona) => {
        if (persona.type === 'user') {
          return userIds.includes(persona.id);
        }

        return persona.members.some((m) => userIds.includes(m.id));
      });

      this.matchedPersonas = [];
    }

    selectPersona(persona) {
      return `@${Utils.normalizeString(persona.name.replace(/\s+/g, ''))}[${persona.id}]`;
    }

    _matchesUser(user, term) {
      const { fullname, email } = user;
      return (
        Utils.normalizeString((fullname || '').toUpperCase()).startsWith(term) ||
        Utils.normalizeString((email || '').toUpperCase()).startsWith(term)
      );
    }

    _matchesGroup(group, term) {
      return Utils.normalizeString((group.name || '').toUpperCase()).startsWith(term);
    }

    filterPersonas(_term) {
      if (!_term.length || !this.users) {
        this.matchedPersonas = [];
        return;
      }

      const term = Utils.normalizeString(_term.toUpperCase());

      this.matchedPersonas = this.personas
        .filter((persona) =>
          this[persona.type === 'user' ? '_matchesUser' : '_matchesGroup'](persona, term)
        )
        .sort((a, b) => (a.fullname || a.name || '').localeCompare(b.fullname || b.name || ''));
    }
  }

  return MentionsFactory;
}
